/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';
import {DISMISS_MSG} from '../../../../common/constants';
import {PlanningMarket} from '../../../../models/planning-market.model';
import {SubregionService} from '../../../../services/subregion.service';

@Component({
    selector: 'app-edit-planning-market-pop-up',
    templateUrl: './edit-planning-market-pop-up.component.html',
    styleUrls: ['./edit-planning-market-pop-up.component.scss'],
    standalone: false
})
export class EditPlanningMarketPopUpComponent implements OnInit {
  plngMkt: PlanningMarket;
  subregions: any[];
  showSpinner: boolean;
  updatedStatus: number;
  updatedSubregion: string;

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: any,
              public readonly subregionService: SubregionService,
              public dialogRef: MatDialogRef<EditPlanningMarketPopUpComponent>,
              public snackBar: FabMessageService) {
    if (data) {
      if (!data.plngMkt) {
        this.dialogRef.close();
      }
      this.plngMkt = data.plngMkt;
      this.updatedStatus = this.plngMkt.active;
      this.updatedSubregion = this.plngMkt.subRegion.toUpperCase();
    }

  }

  ngOnInit() {
    this.showSpinner = true;
    this.subregionService.getSubregions().subscribe({
        next: (response) => {
          this.subregions = response;
        },
        error: () => {
          this.snackBar.displayError('Error loading subregions', DISMISS_MSG);
          this.showSpinner = false;
        },
        complete: () => {
          this.showSpinner = false;
        }
      }
    );
  }

  commitChanges(): void {
    const planningMarket: PlanningMarket = this.plngMkt;
    planningMarket.userId = this.plngMkt.userId;
    planningMarket.plngMkt = this.plngMkt.plngMkt;
    planningMarket.active = this.updatedStatus;
    planningMarket.subRegion = this.updatedSubregion;
    this.dialogRef.close({
      data: planningMarket
    });
  }
}
